import NewsletterEdugoView from 'pages/private/Newsletters/Edugo/NewsletterEdugo';

const NewsletterEdugo = () => {
  return <NewsletterEdugoView />;
};

export default NewsletterEdugo;
